var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sort_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sort_svg__ds{fill:#fff}.sort_svg__dt{opacity:0}.sort_svg__du{fill:#f7f7f7}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "sort_svg__du",
    d: "m141.54,311.62h-50.2c-9.37,0-17,7.63-17,17s7.63,17,17,17h50.2c9.37,0,17-7.63,17-17s-7.63-17-17-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sort_svg__du",
    d: "m237.66,198H91.34c-9.37,0-17,7.63-17,17s7.63,17,17,17h146.32c9.37,0,17-7.63,17-17s-7.63-17-17-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sort_svg__du",
    d: "m338.66,84.38H91.34c-9.37,0-17,7.63-17,17s7.63,17,17,17h247.32c9.37,0,17-7.63,17-17s-7.63-17-17-17Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "sort_svg__dt"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "sort_svg__ds",
    x: 0.5,
    y: 0.5,
    width: 429,
    height: 429
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429,1v428H1V1h428m1-1H0v430h430V0h0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.55fdb7133e6e735fe7274dc157f4d4eb.svg";
export { ForwardRef as ReactComponent };